import React, { useState, useEffect } from 'react';

const svg = require('./SVG');
import { getAllUsers, deleteUserByID, getNewPaidMembersThisSemester, bulkEditUsers } from '../../APIFunctions/User';
import { formatFirstAndLastName } from '../../APIFunctions/Profile';
import { getAllUsersValidVerifiedAndSubscribed } from '../../APIFunctions/User';
// import { membershipState } from '../../Enums';
import ConfirmationModal from
  '../../Components/DecisionModal/ConfirmationModal.js';
const enums = require('../../Enums.js');
import { useSCE } from '../../Components/context/SceContext.js';
import SelectDropdown from './SelectDropdown.js';

const ALL_ROWS = 'all';
const DEFAULT_PAGE_SIZE = 20;
const PAGE_SIZE_OPTIONS = [10, DEFAULT_PAGE_SIZE, 50, ALL_ROWS].map(value => ({
  value,
  label: value === ALL_ROWS ? 'All' : String(value),
}));
const ROLE_OPTIONS = Object.values(enums.membershipState).map(value => ({
  value,
  label: enums.membershipStateToString(value),
}));

export default function Overview() {
  const { user } = useSCE();
  const [toggleDelete, setToggleDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paginationText, setPaginationText] = useState('');
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [userToDelete, setUserToDelete] = useState({});
  const [queryResult, setQueryResult] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(0);
  const [query, setQuery] = useState('');
  // what the user picked in the dropdown. distinct from rowsPerPage, which is
  // the size the server actually used -- under 'all' those two differ.
  const [pageSizeChoice, setPageSizeChoice] = useState(DEFAULT_PAGE_SIZE);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [bulkAccessLevel, setBulkAccessLevel] = useState(
    enums.membershipState.MEMBER
  );
  const [toggleBulkEdit, setToggleBulkEdit] = useState(false);
  const [currentSortColumn, setCurrentSortColumn] = useState('joinDate');
  const [currentSortOrder, setCurrentSortOrder] = useState('desc');
  const [clubRevenueData, setClubRevenueData] = useState({newMembersThisYear:0, newSingleSemesterMembers:0, newAnnualMembers:0, currentActiveMembers:0});
  // const [toggle, setToggle] = useState(false);
  // const [currentQueryType, setCurrentQueryType] = useState('All');
  // const queryTypes = ['All', 'Pending', 'Officer', 'Admin'];

  async function deleteUser(userToDel) {
    const response = await deleteUserByID(
      userToDel._id,
      user.token
    );
    if (response.error) {
      alert('unable to delete user, check logs');
    }
    if (userToDel._id === user._id) {
      // logout
      window.localStorage.removeItem('jwtToken');
      window.location.reload();
      return window.alert('Self-deprecation is an art');
    }
    setUsers(
      users.filter(
        child => !child._id.includes(userToDel._id)
      )
    );
    setTotal(total - 1);
    setQueryResult(
      queryResult.filter(
        child => !child._id.includes(userToDel._id)
      )
    );
    // the row is gone, so leaving it selected would let a bulk edit target a
    // user who is no longer on screen
    setSelectedIds(previouslySelected => {
      const nextSelected = new Set(previouslySelected);
      nextSelected.delete(userToDel._id);
      return nextSelected;
    });
  }

  function mark(bool) {
    return bool ? svg.checkMark() : svg.xMark();
  }

  async function callDatabase() {
    setLoading(true);
    const sortColumn = currentSortOrder === 'none' ? 'joinDate' : currentSortColumn;
    const sortOrder = currentSortOrder === 'none' ? 'desc' : currentSortOrder;
    const apiResponse = await getAllUsers({
      token: user.token,
      query: query,
      page: page,
      sortColumn: sortColumn,
      sortOrder: sortOrder,
      rowsPerPage: pageSizeChoice
    });
    if (!apiResponse.error) {
      setUsers(apiResponse.responseData.items);
      setTotal(apiResponse.responseData.total);
      setRowsPerPage(apiResponse.responseData.rowsPerPage);
    }
    // every refetch replaces the rendered rows, so any prior selection refers
    // to users that are no longer on screen
    setSelectedIds(new Set());
    setLoading(false);
  }

  async function getClubRevenueData() {
    const response = await getNewPaidMembersThisSemester(user.token);
    if(!response.error) {
      setClubRevenueData(response.responseData);
    }
  }

  useEffect(() => {
    callDatabase();
    getClubRevenueData();
  }, [page, currentSortColumn, currentSortOrder, pageSizeChoice]);

  useEffect(() => {

    const amountOfUsersOnCurrentPage = Math.min((page + 1) * rowsPerPage, users.length);
    const pageOffset = page * rowsPerPage;
    const startingElementNumber = (page * rowsPerPage) + 1;
    const endingElementNumber = amountOfUsersOnCurrentPage + pageOffset;
    setPaginationText(
      <>
        <p className='md:hidden text-gray-700 dark:text-white'>
          {startingElementNumber} - {endingElementNumber} / {total}
        </p>
        <p className="hidden md:inline-block text-gray-700 dark:text-white">
          Showing <span className='font-medium'>{startingElementNumber}</span> to <span className='font-medium'>{endingElementNumber}</span> of <span className='font-medium'>{total}</span> results
        </p>
      </>
    );
  }, [page, rowsPerPage, users, total]);

  function handleSortUsers(columnName) {
    if (columnName === null) {
      return;
    }
    if(currentSortColumn === columnName) {
      if (currentSortOrder === 'asc') {
        setCurrentSortOrder('desc');
      } else if (currentSortOrder === 'desc') {
        setCurrentSortOrder('none');
      } else {
        setCurrentSortOrder('asc');
      }
    } else {
      setCurrentSortColumn(columnName);
      setCurrentSortOrder('asc');
    }
  }

  function handlePageSizeChange(pageSize) {
    setPageSizeChoice(pageSize);
    // whatever page we were on probably doesn't exist at the new size
    setPage(0);
  }

  function toggleUserSelection(userId) {
    setSelectedIds(previouslySelected => {
      const nextSelected = new Set(previouslySelected);
      if (nextSelected.has(userId)) {
        nextSelected.delete(userId);
      } else {
        nextSelected.add(userId);
      }
      return nextSelected;
    });
  }

  function toggleSelectAll() {
    setSelectedIds(previouslySelected =>
      previouslySelected.size === users.length
        ? new Set()
        : new Set(users.map(userOnPage => userOnPage._id))
    );
  }

  async function bulkUpdateAccessLevel() {
    const response = await bulkEditUsers(
      [...selectedIds],
      bulkAccessLevel,
      user.token
    );
    if (response.error) {
      return alert('unable to update the selected users, check logs');
    }
    const skipped = response.responseData.skipped || [];
    if (skipped.length) {
      alert(
        `${skipped.length} user(s) were skipped because they outrank you: ` +
        skipped.map(skippedUser => skippedUser.email).join(', ')
      );
    }
    // refetch so the table shows the new roles. this also clears the selection
    callDatabase();
  }

  function handleArrowVisibility(sortOrder, columnName) {
    if (currentSortOrder === sortOrder && currentSortColumn === columnName)
      return '';
    return 'hidden';
  }

  // function filterUserByAccessLevel(accessLevel) {
  //   switch (accessLevel) {
  //     case 'Officer':
  //       return users.filter(
  //         data => data.accessLevel === membershipState.OFFICER
  //       );
  //     case 'Admin':
  //       return users.filter(
  //         data => data.accessLevel === membershipState.ADMIN
  //       );
  //     case 'Pending':
  //       return users.filter(
  //         data => data.accessLevel === membershipState.PENDING
  //       );
  //     default:
  //       return users;
  //   }
  // }

  // function updateQuery(value) {
  //   // taking care of empty values
  //   value = typeof value === 'undefined' ? '' : value;
  //   value = value.trim().toLowerCase();

  //   const userExists = user => {
  //     return (
  //       user.firstName.toLowerCase().includes(value) ||
  //       user.lastName.toLowerCase().includes(value) ||
  //       user.email.toLowerCase().includes(value)
  //     );
  //   };

  //   const filteredUsersByLevel = filterUserByAccessLevel(currentQueryType);
  //   const searchResult = filteredUsersByLevel.filter(data => userExists(data));
  //   const newQueryResult = searchResult.length
  //     ? searchResult
  //     : filteredUsersByLevel;

  //   setQueryResult(newQueryResult);
  // }

  // function handleToggle() {
  //   setToggle(!toggle);
  // }

  function maybeRenderPagination() {
    const amountOfUsersOnCurrentPage = Math.min((page + 1) * rowsPerPage, users.length);
    const pageOffset = page * rowsPerPage;
    const endingElementNumber = amountOfUsersOnCurrentPage + pageOffset;
    if (users.length) {
      return (
        <nav className='flex justify-start py-6'>
          <div className='flex items-center navbar-start'>
            <span className="text-gray-700 dark:text-white">
              {loading ? '...' : paginationText}
            </span>
          </div>
          <div className='flex justify-end space-x-3 navbar-end'>
            <button
              className='btn btn-neutral text-gray-800 bg-gray-500 hover:bg-gray-300 dark:text-white dark:bg-gray-700 dark:hover:bg-gray-600'
              onClick={() => setPage(page - 1)}
              disabled={page === 0 || loading}
            >
              previous
            </button>
            <button
              className='btn btn-neutral text-gray-800 bg-gray-200 hover:bg-gray-300 dark:text-white dark:bg-gray-700 dark:hover:bg-gray-600'
              onClick={() => setPage(page + 1)}
              disabled={endingElementNumber >= total || loading}
            >
              next
            </button>
          </div>
        </nav>
      );
    }
    return <></>;
  }

  return (
    <div className='overview-container bg-white dark:bg-gradient-to-r dark:from-gray-800 dark:to-gray-600 min-h-[100dvh]'>
      <ConfirmationModal {... {
        id: 'delete-user-modal',
        headerText: `Delete ${userToDelete.firstName} ${userToDelete.lastName} ?`,
        bodyText: `Are you sure you want to delete 
          ${userToDelete.firstName}? They'll be gone forever if you do.`,
        confirmText: `Yes, goodbye ${userToDelete.firstName}`,
        cancelText: 'No, they\'re chill',
        confirmClassAddons: 'bg-red-600 hover:bg-red-500',
        handleConfirmation: () => {
          deleteUser(userToDelete);
          setToggleDelete(!toggleDelete);
        },
        handleCancel: () => setToggleDelete(!toggleDelete),
        open: toggleDelete
      }
      } />
      <ConfirmationModal {... {
        id: 'bulk-edit-modal',
        headerText: `Change ${selectedIds.size} user(s) to ` +
          `${enums.membershipStateToString(bulkAccessLevel)}?`,
        bodyText: 'This updates every selected user at once. Users who ' +
          'outrank you will be skipped.',
        confirmText: 'Yes, update them',
        cancelText: 'Never mind',
        handleConfirmation: () => {
          bulkUpdateAccessLevel();
          setToggleBulkEdit(!toggleBulkEdit);
        },
        handleCancel: () => setToggleBulkEdit(!toggleBulkEdit),
        open: toggleBulkEdit
      }
      } />
      <div className='px-4'>
        <button className="my-8 btn btn-primary lg:max-w-[20%]" onClick={async () => {
          const result = await getAllUsersValidVerifiedAndSubscribed(user.token);
          if (result.error) {
            return alert(
              'unable to download email list: ' + result.error
            );
          }
          const blob = new Blob([result.responseData]);
          const date = new Date().toISOString().split('T')[0].replace(/-/g, '');

          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = `${date}_sce_emails_export.csv`;
          a.click();
        }}>
            Download subscribed emails
        </button>
        <div className='mb-8 text-base text-gray-900 dark:text-white'>
          <p className='mb-2'>Total New Members this Year: {clubRevenueData.newMembersThisYear}</p>
          <p className='mb-2'>Current Active Members: {clubRevenueData.currentActiveMembers}</p>
        </div>
        <div className='px-6 border rounded-lg border-gray-300 dark:border-white/10'>
          <div className='flex flex-col gap-4 py-6 sm:flex-row sm:items-end'>
            <label className="w-full form-control sm:flex-1">
              <div className="label">
                <span className="label-text text-md text-gray-700 dark:text-white">Type a search, followed by the enter key</span>
              </div>
              <input
                className="w-full text-sm input input-bordered text-gray-900 dark:text-white sm:text-base"
                type="text"
                placeholder="search by first name, last name, or email"
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    // instead of calling the backend directory, set
                    // the page we are on to zero if the current page
                    // we are on isn't the first page (value of 0).
                    // by doing this, the useEffect will call the backend
                    // for us with the correct page and query.
                    if (page) {
                      setPage(0);
                    } else {
                      callDatabase();
                    }
                  }
                }}
                onChange={event => {
                  setQuery(event.target.value);
                }}
              />
            </label>
            <div className='relative w-full sm:w-48 sm:shrink-0'>
              <SelectDropdown
                label='Entries per page'
                options={PAGE_SIZE_OPTIONS}
                value={pageSizeChoice}
                onChange={handlePageSizeChange}
                disabled={loading}
              />
            </div>
          </div>
          {selectedIds.size > 0 && (
            <div className='flex flex-col gap-4 mb-6 p-4 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-300 dark:border-gray-700 sm:flex-row sm:items-end'>
              <span className='text-sm font-medium text-gray-700 dark:text-gray-300 sm:flex-1'>
                {selectedIds.size} selected
              </span>
              <div className='relative w-full sm:w-48 sm:shrink-0'>
                <SelectDropdown
                  label='Set membership status to'
                  options={ROLE_OPTIONS}
                  value={bulkAccessLevel}
                  onChange={setBulkAccessLevel}
                />
              </div>
              <div className='flex gap-2'>
                <button
                  onClick={() => setToggleBulkEdit(!toggleBulkEdit)}
                  className='px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500'
                >
                  Apply
                </button>
                <button
                  onClick={() => setSelectedIds(new Set())}
                  className='px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500'
                >
                  Clear
                </button>
              </div>
            </div>
          )}
          <table className='table px-3'>
            <thead>
              <tr>
                <th className='w-px'>
                  <div className='flex items-center justify-center'>
                    <input
                      type='checkbox'
                      className='form-checkbox h-4 w-4 text-blue-600 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 rounded focus:ring-blue-500'
                      aria-label='Select every user on this page'
                      disabled={users.length === 0}
                      checked={
                        users.length > 0 && selectedIds.size === users.length
                      }
                      // indeterminate is a DOM property, not an attribute, so
                      // react can't set it declaratively
                      ref={checkbox => {
                        if (checkbox) {
                          checkbox.indeterminate =
                            selectedIds.size > 0 &&
                            selectedIds.size < users.length;
                        }
                      }}
                      onChange={toggleSelectAll}
                    />
                  </div>
                </th>
                {[
                  { title: 'Name/Email', className: 'text-base text-gray-700 dark:text-white/70', columnName: 'email'},
                  { title: 'Printing', className: 'text-base text-gray-700 dark:text-white/70 hidden text-center md:table-cell', columnName: 'pagesPrinted'},
                  { title: 'Verified', className: 'text-base text-gray-700 dark:text-white/70 text-center hidden sm:table-cell', columnName: 'emailVerified'},
                  { title: 'Membership', className: 'text-base text-gray-700 dark:text-white/70 hidden text-center sm:table-cell', columnName: 'accessLevel'},
                  { title: 'Delete', className: 'text-base text-gray-700 dark:text-white/70 text-center'},
                ].map(({ title, className, columnName = null}) => (
                  <th
                    className={`${className}`}
                    key={title}
                  >
                    <div className="flex items-center justify-center">
                      <button onClick={() => handleSortUsers(columnName)}>{title}</button>
                      <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth='1.5' stroke='currentColor' className={`w-5 h-5 ${handleArrowVisibility('asc', columnName)}`}>
                        <path strokeLinecap='round' strokeLinejoin='round' d='M12 19.5V4.5m0 0l-6 6m6-6l6 6' />
                      </svg>
                      <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth='1.5' stroke='currentColor' className={`w-5 h-5 ${handleArrowVisibility('desc', columnName)}`}>
                        <path strokeLinecap='round' strokeLinejoin='round' d='M12 4.5v15m0 0l6-6m-6 6l-6-6' />
                      </svg>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr className='break-all !rounded md:break-keep hover:bg-gray-100 dark:hover:bg-white/10' key={user.email}>
                  <td className='w-px'>
                    <div className='flex items-center justify-center'>
                      <input
                        type='checkbox'
                        className='form-checkbox h-4 w-4 text-blue-600 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 rounded focus:ring-blue-500'
                        aria-label={`Select ${user.email}`}
                        checked={selectedIds.has(user._id)}
                        onChange={() => toggleUserSelection(user._id)}
                      />
                    </div>
                  </td>
                  <td className=''>
                    <a className='link link-hover text-blue-600 dark:text-blue-400' target="_blank" rel="noopener noreferrer" href={`/user/edit/${user._id}`}>
                      {formatFirstAndLastName(user)}
                    </a>
                    <p className="text-gray-900 dark:text-gray-200">{user.email}</p>
                  </td>
                  <td className='hidden md:table-cell'>
                    <div className='flex items-center justify-center text-gray-900 dark:text-gray-200'>
                      {user.pagesPrinted}/30
                    </div>
                  </td>
                  <td className='hidden sm:table-cell'>
                    <div className='flex items-center justify-center'>
                      {mark(user.emailVerified)}
                    </div>
                  </td>
                  <td className='hidden sm:table-cell'>
                    <div className='flex items-center justify-center text-gray-900 dark:text-gray-200'>
                      {enums.membershipStateToString(user.accessLevel)}
                    </div>
                  </td>
                  <td>
                    <div className='flex items-center justify-center'>
                      <button
                        className='p-2 hover:bg-gray-200 dark:hover:bg-white/30 rounded-xl'
                        onClick={() => {
                          setToggleDelete(!toggleDelete);
                          setUserToDelete(user);
                        }}
                      >
                        {svg.trashcanSymbol()}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}

            </tbody>
          </table>
          {users.length === 0 && (
            <div className='flex flex-row w-100 justify-center'>
              <p className='text-lg text-gray-700 dark:text-white/70 mt-5 mb-5'>No results found!</p>
            </div>
          )}
          {maybeRenderPagination()}
        </div>
      </div>
    </div>
  );
}
